import { WorkflowConstants } from 'constants/workflowConstants';
import { createAction } from 'redux-actions';

export const startAction = createAction(WorkflowConstants.START_ACTION);
export const checkinAction = createAction(WorkflowConstants.CHECKIN_ACTION);
export const nextAction = createAction(WorkflowConstants.NEXT_ACTION);
export const backAction = createAction(WorkflowConstants.BACK_ACTION);
export const redirectAction = createAction(WorkflowConstants.REDIRECT_ACTION);
export const getRedirectionDataAction = createAction(WorkflowConstants.GET_REDIRECT_DATA_ACTION);
export const validateRoutingNumberAction = createAction(WorkflowConstants.VALID_ROUTING_NUMBER);
export const getLTVOptions = createAction(WorkflowConstants.GET_LTV_OPTIONS);
export const uploadImageToPreSignedUrlAction = createAction(WorkflowConstants.UPLOAD_IMAGE_TO_PRESIGNED_URL);
export const getIPAddress = createAction(WorkflowConstants.GET_IP_ADDRESS);
export const resumeApplicationAction = createAction(WorkflowConstants.RESUME_APPLICATION);
export const selectOfferAction = createAction(WorkflowConstants.SELECT_OFFER);
export const saveLoanDetails = createAction(WorkflowConstants.SAVE_LOAN_DETAILS);
